export default __webpack_public_path__ + "static/small-image-19-66406bd12c910cc64fe8570f53baee75.png";